var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRallyPowerUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#253FF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1242_4814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3198 4.04311L6.78079 9.07776C6.58829 9.29485 6.64401 9.61355 6.90237 9.76136L9.79498 11.4149L8.57411 15.8584C8.53864 15.9784 8.71088 16.057 8.797 15.96L13.2144 10.8468C13.4019 10.6297 13.3411 10.311 13.0827 10.1678L10.2813 8.60662L11.5376 4.14473C11.5731 4.02464 11.4009 3.94612 11.3147 4.04311H11.3198Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1242_4814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.66667,
    height: 12,
    fill: "white",
    transform: "translate(6.66602 3.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRallyPowerUp);
export default __webpack_public_path__ + "static/media/rallyPowerUp.20226501ca9541cc59aad30940ad2836.svg";
export { ForwardRef as ReactComponent };